import { jsx as _jsx } from "react/jsx-runtime";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { ContactFormLink } from "@faire/web--source/ui/ContactFormLink";
import { trackCxFoundationsContactFormLinkRetailerWebClick } from "@faire/web-api--source/events/cxFoundations/click/contactFormLinkRetailerWeb";
import React from "react";
var onContactFormClick = function() {
    return trackCxFoundationsContactFormLinkRetailerWebClick(getCurrentPath().toString());
};
export var LoggedOutContactFormLinkFormatting = function(chunk, onClick) {
    return /*#__PURE__*/ _jsx(ContactFormLink, {
        loggedOut: true,
        onClick: function() {
            onContactFormClick();
            onClick === null || onClick === void 0 ? void 0 : onClick();
        },
        children: chunk
    });
};
export var ContactFormLinkFormatting = function(chunk) {
    return /*#__PURE__*/ _jsx(ContactFormLink, {
        onClick: onContactFormClick,
        children: chunk
    });
};
